export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getPaginatedAdmins(_, page) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/index?page=" + page)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        deleteAdmin(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/delete/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        createAdmin(_, data) {
            let formData = new FormData();
            Object.keys(data).forEach(key => {
                if (data[key]) {
                    formData.append(key, data[key])
                }
            });
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/store", formData)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        updateAdmin(_, payload) {
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/update/" + payload.identifier, payload.data)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        singleAdmin(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/show/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
    },
}

